/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DeploymentMetricSeriesDto } from './DeploymentMetricSeriesDto';
import {
    DeploymentMetricSeriesDtoFromJSON,
    DeploymentMetricSeriesDtoFromJSONTyped,
    DeploymentMetricSeriesDtoToJSON,
} from './DeploymentMetricSeriesDto';

/**
 * 
 * @export
 * @interface DeploymentMetricsDto
 */
export interface DeploymentMetricsDto {
    /**
     * The metrics with their datapoints.
     * @type {Array<DeploymentMetricSeriesDto>}
     * @memberof DeploymentMetricsDto
     */
    metrics: Array<DeploymentMetricSeriesDto>;
}

/**
 * Check if a given object implements the DeploymentMetricsDto interface.
 */
export function instanceOfDeploymentMetricsDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "metrics" in value;

    return isInstance;
}

export function DeploymentMetricsDtoFromJSON(json: any): DeploymentMetricsDto {
    return DeploymentMetricsDtoFromJSONTyped(json, false);
}

export function DeploymentMetricsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeploymentMetricsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'metrics': ((json['metrics'] as Array<any>).map(DeploymentMetricSeriesDtoFromJSON)),
    };
}

export function DeploymentMetricsDtoToJSON(value?: DeploymentMetricsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'metrics': ((value.metrics as Array<any>).map(DeploymentMetricSeriesDtoToJSON)),
    };
}

